module.exports = __webpack_public_path__ + "img/SI.8dbe0a3b.svg";